import type { SeveralRowsValueProps } from 'entities/history';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import classNames from 'classnames';

import { transformEventData } from './SeveralRowsHelpers';

export function SeveralRowsValue({ data, wrapperClass }: SeveralRowsValueProps) {
  const transformedData = transformEventData(data);

  return (
    <div data-testid="TestId__several_rows_value">
      {transformedData.map((dataPair) => (
        <div
          className={classNames('flex items-center border-b border-slate-100 py-2 text-xs last:border-0', wrapperClass)}
          key={dataPair.key}
          {...getDataAutoTestAttributes([`several-rows-value-${dataPair.key.toLowerCase().replace(/\s/g, '-')}`])
            .attributes}
        >
          <span className="mr-[6px] font-semibold">{dataPair.key}:</span>
          {dataPair.value}
        </div>
      ))}
    </div>
  );
}
